/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TransactionsDateRange/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaInputDateRange from 'DesignSystem/TysiaInputDateRange/index'



/** @type {import('Simple/types.js').View} */
export default function TransactionsDateRange({
  children,
  viewPath = "/App/Account/Content/Financial/Content/Statements/New/TransactionsDateRange",
  onChange
  
}) {
let daterangeValueData = fromData.useDataValue({ viewPath,
context: 'daterange',
})
let daterangeChangeData = fromData.useDataChange({ viewPath,
context: 'daterange',
})
let daterangeTemplatesValueData = fromData.useDataValue({ viewPath,
context: 'daterange',
path: 'templates',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaInputDateRange
  viewPath={`${viewPath}/TysiaInputDateRange`}
 required={true}
 marginTop={dtSpaceS}
 offsetMainAxis={10}
 offsetCrossAxis={-405}
 label="Transactions date range"
 data="daterange"
 daterange={daterangeValueData}
 onChange={daterangeChangeData}
 data="daterange.templates"
 templates={daterangeTemplatesValueData}
/>
{children}
</React.Fragment>)
}